"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    aggregateNestedSettledRejections: function() {
        return aggregateNestedSettledRejections;
    },
    asPromise: function() {
        return asPromise;
    },
    getSettledFulfilledResults: function() {
        return getSettledFulfilledResults;
    },
    getSettledRejectionResults: function() {
        return getSettledRejectionResults;
    },
    getSettledResults: function() {
        return getSettledResults;
    }
});
async function asPromise(value) {
    if (isThenable(value)) {
        return value;
    }
    return Promise.resolve(value);
}
function isThenable(obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}
function aggregateNestedSettledRejections(settledPromises) {
    const errors = [];
    for (const promise of settledPromises){
        if (promise.status === 'fulfilled' && isSettledPromiseArray(promise.value)) {
            errors.push(...aggregateNestedSettledRejections(promise.value));
        } else if (promise.status === 'rejected') {
            errors.push(promise.reason);
        }
    }
    return errors;
}
function getSettledResults(settledPromises) {
    const interleaved = [];
    const results = [];
    const errors = [];
    settledPromises.forEach((promise, index)=>{
        if (promise.status === 'rejected') {
            const value = {
                error: promise.reason,
                index
            };
            errors.push({
                error: promise.reason,
                index
            });
            interleaved.push(promise.reason);
        } else {
            const value = {
                result: promise.value,
                index
            };
            results.push(value);
            interleaved.push(promise.value);
        }
    });
    const out = {
        results,
        interleaved,
        errors
    };
    return out;
}
function getSettledRejectionResults(settledPromises) {
    const errors = [];
    settledPromises.forEach((promise, index)=>{
        if (promise.status === 'rejected') {
            errors.push({
                error: promise.reason,
                index
            });
        }
    });
    return errors;
}
function getSettledFulfilledResults(settledPromises) {
    const results = [];
    settledPromises.forEach((promise, index)=>{
        if (promise.status === 'fulfilled') {
            results.push({
                result: promise.value,
                index
            });
        }
    });
    return results;
}
function isSettledPromiseArray(item) {
    return Array.isArray(item) && item.length > 0 && (item[0].status === 'fulfilled' || item[0].status === 'rejected');
}

//# sourceMappingURL=promises.js.map